import React from 'react';
import { useFormState } from 'informed';
import { Button, themes } from '@digitools/honest-react';
export const FormButton = (props) => {
    const formState = useFormState();
    return (<Button data-public={true} onClick={props.onClick} id={'btn' + props.idName} type='submit' buttonType={'primary'} theme={themes.lincoln} size={'medium'} disabled={!props.hasChanged || formState.invalid}>
      {props.displayText}
    </Button>);
};
